import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl text-background-50 cursor-pointer">
              UU漫画
            </Link>
            <p className="mt-3 text-sm text-background-50/80 leading-relaxed">
              漫画追更，最新漫画更新，连载漫画同步阅读。追漫必备平台，免费漫画全集随时看，不再错过任何章节。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/rexue" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/rexue" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">热血漫画</Link>
              <Link to="/category/lianai" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">恋爱漫画</Link>
              <Link to="/category/xuanyi" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">悬疑漫画</Link>
              <Link to="/category/qihuan" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">奇幻漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm text-background-50/70">邮箱：contact@uumanhua.com</p>
              <p className="text-sm text-background-50/70">QQ群：888888888</p>
              <p className="text-sm text-background-50/70">工作时间：周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/60">
            &copy; 2026 UU漫画 - 漫画追更平台 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50/80 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50/80 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50/80 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}